module.exports = __webpack_public_path__ + "img/108032.b42eb013.png";